var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue merida"},[_c('div',{ref:"board",staticClass:"cg-board-wrap"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{staticClass:"button",on:{"click":_vm.takeBack}},[_vm._v("Take back")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aae4aebe","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chessboard.vue
// module id = 37
// module chunks = 0